import React from 'react';
import { FiLogOut, FiX } from 'react-icons/fi';
import './LogoutModal.css';

const LogoutModal = ({ isOpen, onConfirm, onCancel, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="logout-modal">
      <div className="logout-modal__overlay" onClick={onCancel} />
      <div className="logout-modal__container">
        <button className="logout-modal__close" onClick={onCancel}>
          <FiX />
        </button>
        
        <div className="logout-modal__icon">
          <FiLogOut />
        </div>
        
        <h2 className="logout-modal__title">Keluar dari Akun?</h2>
        
        <p className="logout-modal__message">
          Apakah Anda yakin ingin keluar dari sistem perpustakaan? 
          Anda perlu login kembali untuk mengakses akun.
        </p>
        
        <div className="logout-modal__actions">
          <button 
            className="logout-modal__btn logout-modal__btn--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Batal
          </button>
          <button 
            className="logout-modal__btn logout-modal__btn--confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="logout-modal__spinner"></span>
                Keluar...
              </>
            ) : (
              <>
                <FiLogOut />
                Ya, Keluar
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
